import { render } from "./product-details.vue?vue&type=template&id=8739d706&scoped=true&ts=true"
import script from "./product-details.vue?vue&type=script&lang=ts"
export * from "./product-details.vue?vue&type=script&lang=ts"

import "./product-details.vue?vue&type=style&index=0&id=8739d706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8739d706"]])

export default __exports__